module.exports = __webpack_public_path__ + "img/prestogo_login_dark.abba95c0.png";